import { create } from "zustand/react";
import { useShallow } from "zustand/react/shallow";

interface BotsStore {
  state: string;
  searchKeyword: string;
  selectedOrganizationId?: string;
  actions: {
    setSearchKeyword: (keyword: string) => void;
    unMount: () => void;
    setState: (state: string) => void;
  };
}

const defaultBotsStoreData = {
  state: "active",
  searchKeyword: "",
  selectedOrganizationId: undefined,
};

const useBotStore = create<BotsStore>((set) => ({
  ...defaultBotsStoreData,
  actions: {
    setSearchKeyword: (keyword) =>
      set(() => ({
        searchKeyword: keyword,
      })),
    unMount: () =>
      set(() => ({
        ...defaultBotsStoreData,
      })),
    setState: (state) =>
      set(() => ({
        state,
      })),
  },
}));

// https://github.com/pmndrs/zustand?tab=readme-ov-file#selecting-multiple-state-slices
export const useBotsData = () =>
  useBotStore(
    useShallow((state) => ({
      state: state.state,
      searchKeyword: state.searchKeyword,
    })),
  );

export const useBotsActions = () => useBotStore((state) => state.actions);
